import { gql } from "@apollo/client";

export const updateKeywordGroup = gql`
  mutation UpdateKeywordGroup($id: ID!, $input: KeywordGroupInput!) {
    updateKeywordGroup(id: $id, input: $input) {
      id
      name
      slug
      imageUrl
      type
      category
      keywords
      keywordsGroupIds
      metadata
    }
  }
`;
